import template from '@/store/modules/productions/template'

export default {
  namespaced: true,
  modules: {
    template
  }
}
